





















import { useSave } from '@/composables';
import { BaseModuleEditor } from '../base';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'NotesEditor',
  mixins: [BaseModuleEditor],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  setup(props: any) {
    const { buffer, save } = useSave(props, {
      path: 'notes',
    });

    return {
      buffer,
      save,
    };
  },
});
